<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="form" :rules="rules" class="login-form" autocomplete="on" label-position="left">

      <div class="title-container">
        <h3 class="title">系统登录</h3>
      </div>

      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon class="icon-blcu-system-user" />
        </span>
        <el-input
          ref="username"
          v-model="form.account"
          placeholder="用户名"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="on"
        />
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon class="icon-blcu-suo" />
          </span>
          <el-input
            :key="passwordType"
            ref="password"
            v-model="form.password"
            :type="passwordType"
            placeholder="密码"
            name="password"
            tabindex="2"
            autocomplete="on"
            @blur="capsTooltip = false"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :class="passwordType === 'password' ? 'icon-blcu-eye1' : 'icon-blcu-eye'" />
          </span>
        </el-form-item>
      </el-tooltip>
  
      <el-row>
        <el-col :span="12">
          <el-form-item prop="username" >
            <el-input
                ref="verifyCode"
                v-model="form.verifyCode"
                placeholder="验证码"
                name="verifyCode"
                type="text"
                tabindex="1"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div @click="refreshCode" style="margin-left: 25px; ">
            <img :src="imgURL"  style=" vertical-align:middle;"/>
          </div>
        </el-col>
      </el-row>
      
      <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="onSubmit('loginForm')">登录</el-button>
    </el-form>

    <!--<el-dialog title="Or connect with" :visible.sync="showDialog">-->
      <!--Can not be simulated on local, so please combine you own business simulation! ! !-->
      <!--<br>-->
      <!--<br>-->
      <!--<br>-->
      <!--<social-sign />-->
    <!--</el-dialog>-->
  </div>
</template>

<script>

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      callback()
    }
    const validatePassword = (rule, value, callback) => {
      callback()
    }
    return {
      form: {
        account: '',
        password: '',
        verifyCode:'',
        VCode: '123',
      },
      imgURL: '',
      rules: {
        account: [
          {required: true, message: '账号不可为空', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '密码不可为空', trigger: 'blur'}
        ],
        verifyCode: [
          {required: true, message: '验证码不可为空', trigger: 'blur'}
        ]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {}
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created() {
    this.refreshCode();
  },
  mounted() {
    if (this.form.username === '') {
      this.$refs.account.focus()
    } else if (this.form.password === '') {
      this.$refs.password.focus()
    }
  },
  destroyed() {
  },
  methods: {
    refreshCode() {
      this.https.fetchGet("/ssoLogin/getCode" ,"" ,"blob").then((data) => {
        let file = window.URL.createObjectURL(data.data);
        this.imgURL = file;
        this.form.VCode = data.headers.vcode;
      }).catch(err=>{
            console.log(err)
          }
      )
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm)
            .then(() => {
              this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    getEblcu() {
      ///ssoLogin/getEblcu
      this.https.fetchGet("ssoLogin/getEblcu" ,"" ,"").then((data) => {
        let code = data.data.code;
        let msg = data.data.msg;
        if(code == '200') {
          this.$store.commit("setEblcuOrg",data.data.data);
        }
      }).catch(err=>{
            console.log(err)
          }
      )
    },
    
    selectMenu() {
      let params = {
        appId: "manager"
      };
      this.https.fetchPost('/managerPermission/selectMenuTree', params).then((data) => {
        let code = data.data.code;
        console.log(data.data.code)
        if (code == '200') {
          let menus = data.data.data
          console.log(menus);
          
        }
      }).catch(err => {
            console.log(err)
      })
    },
    
    onSubmit(formName) {
      // 为表单绑定验证功能
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.form;
          let header = [];
          let VCode = {
            key: 'VCode',
            value: this.form.VCode
          }
          header.push(VCode);
          this.https.fetchPost('/ssoLogin/login',params ,"json",header).then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if(code == '200') {
              this.$store.commit("setIsLogin","1");
              this.$store.commit("setOrgCode",data.data.data.orgCode);
              this.$store.commit("seOrgType",data.data.data.orgType);
              this.$store.commit("setUser",data.data.data.user);
              this.$store.commit("setToken",data.data.data.token);
              this.getEblcu();
              this.selectMenu();
              this.$router.push("/");
            } else {
              this.$message({
                type: 'info',
                message: '登录失败:'+msg
              });
            }
          }).catch(err=>{
                console.log(err)
              }
          )

        } else {
          this.dialogVisible = true;
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg:#283443;
$light_gray:#fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg:#2d3a4b;
$dark_gray:#889aa4;
$light_gray:#eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 35px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
